import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-city-edit',
  templateUrl: './city-edit.component.html',
  styleUrls: ['./city-edit.component.css']
})
export class CityEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
